import { Box, Button, Stack } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router'

import style from './style'
import { useLanguage } from '../../../LanguageContext'

const Footer: React.FC = () => {
  const language = useLanguage()

  const scrollToTop = () => {
    window.scrollTo(0, 0)
  }

  return (
    <Box component="footer" sx={style.footer}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
        <Box component="img" src="/images/logo.png" alt="logo" width={110} />
        <Box sx={style.desktopVisible}>
          <FormattedMessage
            id="Footer.AllRightsReserved"
            defaultMessage="© 2025 QuantumBio Vins - All rights reserved"
          />
        </Box>
        <Stack direction="column" alignItems="flex-end">
          <Button component={Link} to={`/${language}/contact`} variant="text" onClick={scrollToTop}>
            <FormattedMessage id="Footer.Contact" defaultMessage="Contact" />
          </Button>
          <Button
            component={Link}
            to={`/${language}/legal-notice`}
            variant="text"
            onClick={scrollToTop}
          >
            <FormattedMessage id="Footer.LegalNotice" defaultMessage="Legal notice" />
          </Button>
        </Stack>
      </Stack>
      <Box sx={style.mobileVisible}>
        <FormattedMessage
          id="Footer.AllRightsReserved"
          defaultMessage="© 2025 QuantumBio Vins - All rights reserved"
        />
      </Box>
    </Box>
  )
}

export default Footer
